var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26 26",
    style: {
      enableBackground: "new 0 0 26 26"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{stroke:#000000;stroke-width:0.3237;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_300_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2460_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_554_",
    d: "M24.4,26H1.6C0.7,26,0,25.3,0,24.4V1.6C0,0.7,0.7,0,1.6,0h22.8C25.3,0,26,0.7,26,1.6v22.8 C26,25.3,25.3,26,24.4,26z M1.6,1.6v22.8h22.8V1.6H1.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_231_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_405_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1221_",
    d: "M10.5,18.4l-5.6-5.3c-0.2-0.2-0.2-0.4,0-0.6l0.6-0.6c0.2-0.2,0.4-0.2,0.6,0l4.8,4.5l10.1-10 c0.2-0.2,0.4-0.2,0.6,0L22,7c0.2,0.2,0.2,0.4,0,0.6L11,18.3C10.9,18.5,10.6,18.5,10.5,18.4z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBox);
export default __webpack_public_path__ + "static/media/CheckBox.fe8f6cf083473fb1ce7a32d9eb22c970.svg";
export { ForwardRef as ReactComponent };